import React, { useEffect, useContext, createContext } from 'react'
import ReactDOM from 'react-dom'
import Promise from 'es6-promise'
import axios from 'axios'
import ProductList from './productList'
import ProductFilter from './productFilter'
import ReactMap from "./react-map";
import MapContextProvider from "./map-context";
import HeroFilter from './heroFilter'

import 'loader-blocks.gif';

const Loader = props => (
	<div className="loader small-12 cell text-center">
		<img src={require(`loader-blocks.gif`)}/>
	</div>
);

class ProductGrid extends React.Component {

	constructor(props) {
		
		super(props);
		this.state = {
			loading: true,
			products: [],
			promoted: [],
			virtual: [],
			show: this.props.loadMore ? this.props.visible : false,

			filters: {
				location: this.props.config.filters.location,
				category: this.props.config.filters.category,
				subcategory: this.props.config.filters.subcategory,
				section: this.props.config.filters.section,
				supplier: this.props.config.filters.supplier
			},

			search: {
				type: this.props.config.type,
				order: this.props.config.order != undefined ? this.props.config.order : 1,
				filters: {
					location: this.props.config.filters.location.value,
					category: this.props.config.filters.category.value,
					subcategory: this.props.config.filters.subcategory.value,
					section: this.props.config.filters.section.value,
					supplier: this.props.config.filters.supplier.value,
					tag: null
				},
				dataonly: 0,
				promoted: this.props.promoted
			},
			path: this.props.path,
			view: 'grid',
			renderFilter: true,
			highlighted: 0
		}
		//this.loadMore = this.loadMore.bind(this);		
	}

	handleLoadMore = () => {
		this.setState((prev) => {
		  return {show: prev.show + 20};
		});
	  }

	componentDidMount = () => {
		window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
		this.sendData( this.state.search, 0 );
	}

	componentWillUnmount = () => {
		this.serverRequest.abort();
	}

	sendData = ( searchParams, dataOnly ) => {

		searchParams.dataonly = dataOnly;

		const url = '/products/list';
		axios.post( url, {
				authenticity_token: this.props.token,
				search: searchParams
		}).then( response => {

			this.setState({
				loading: false,
				products: response.data.items.products,
				promoted: response.data.items.promoted,
				virtual: response.data.items.virtual,
				renderFilter: true
			});

			if( typeof response.data.filters != 'undefined' ) {
				this.setFilterData( response.data.filters);
			}

		}).catch(err => {
			console.log(err);
		});
	}

	setFilterData = (filterData) => {

		const filters = this.state.filters;
		Object.keys( filterData ).map(( ident ) => {
			if( filterData[ident] != null ) {
				filters[ident].data = filterData[ident];
			}
		});
		this.setState({ filters: filters });
	}

	updateFilter = (ident, obj) => {

		//copy the current state
		const newSearchState = this.state.search;

		//set the parameters for the search
		newSearchState.filters[ident] = obj.value;

		this.setState({
			loading: true,
			search: newSearchState
		});


		this.sendData( newSearchState, 1 );
	}

	handleOrderChange = (e) => {
		e.preventDefault();
		e.stopPropagation();

		const newSearchState = this.state.search;
		newSearchState.order = e.target.value;

		this.setState({
			loading: true,
			search: newSearchState
		});

		this.sendData( newSearchState, 1 );
	}

	handleGridView = (e) => {
		e.preventDefault();
		e.stopPropagation();
		this.setState({
			view: 'grid'
		});
	}

	handleListView = (e) => {
		e.preventDefault();
		e.stopPropagation();
		this.setState({
			view: 'list'
		});
	}

	handleMapView = (e) => {
		e.preventDefault();
		e.stopPropagation();
		window.top.location.reload(true)
		setTimeout(() => {
			this.setState({
				view: 'map'
			});
		}, 2000);
	}

	testFunction = (e) => {
		alert('test function called');
	}

	render() {

		return (
			<MapContextProvider>
			<div>

				<ProductFilter
					renderFilter={this.state.renderFilter}
					filters={this.state.filters}
					slug={this.props.config.slug}
					order={this.state.search.order}
					updateFilter={(ident,obj) => this.updateFilter(ident,obj)}
					handleOrderChange={(event) => this.handleOrderChange(event)}
					handleListView={(event) => this.handleListView(event)}
					handleGridView={(event) => this.handleGridView(event)}
					handleMapView={(event) => this.handleMapView(event)}
					showMap={this.props.showMap}
				/>

				{ this.props.config.heroFilter && <HeroFilter config={this.props.config.heroFilter} filters={this.state.search.filters} updateFilter={this.updateFilter} /> }

				
				{ this.state.loading ?
					<Loader/>
					:
					<div className="grid-x grid-padding-x">
						<div className='cell medium-12'>
							<ProductList
							products={this.state.products}
							promoted={this.state.promoted}
							virtual={this.state.virtual}
							handleLoadMore={this.handleLoadMore}
							location={this.props.locationName}
							loadMore={this.props.loadMore}
							visible={this.state.show}
							cdnPath={this.props.cdnPath}
							config={this.props.config}
							path={this.state.path}
							view={this.state.view}
							highlighted={this.state.highlighted}
							highlightItem={( item ) => this.setState({ highlighted: item })}
							showMap={this.props.showMap}
						  />
						</div>

						{ this.state.view == 'map' && this.props.showMap == true ?
						<div className="cell medium-12 large-7 small-order-1 large-order-2">
							<div className="activity-map">
								<div id="sticky-container" className="sticky-container">
									<div id="safari-container">
										<div className="testmap">
											<ReactMap
												products={this.state.products}
												cdnPath={this.props.cdnPath}
												highlighted={this.state.highlighted}
												highlightItem={( item ) => this.setState({ highlighted: item })}
												showMap={this.props.showMap}
											/>
										</div>
									</div>
									<div id="bottom-content"></div>
								</div>
							</div>
						</div>
						: <><div id="safari-container"><div className="testmap"></div></div><div id="bottom-content"></div></> }
					</div>
				}
			</div>
			</MapContextProvider>
		)
	}
}

document.addEventListener('DOMContentLoaded', () => {

	const grid = document.querySelector('#react-product-grid');
	const config = JSON.parse(grid.getAttribute('config'));
	const locationId = grid.getAttribute('locationId');
	const cdnPath = grid.getAttribute('cdnPath');
	const token = grid.getAttribute('token');
	const locationName = grid.getAttribute('locationName');
	const loadMore = grid.getAttribute('loadMore') == 'true' ? true : false;
	const showMap = grid.getAttribute('showMap') == 'true' ? true : false;
	const visible = parseInt( grid.getAttribute('visible') );
	const promoted = grid.getAttribute('promoted') == 'true' ? true : false;
	const path = grid.getAttribute('path');
	ReactDOM.render(
		<ProductGrid locationId={locationId} locationName={locationName} showMap={showMap} loadMore={loadMore} visible={visible} promoted={promoted} cdnPath={cdnPath} token={token} config={config} path={path} />,
		grid,
	)
})
